import { render, staticRenderFns } from "./NDVBase.vue?vue&type=template&id=2909284c&"
import script from "./NDVBase.vue?vue&type=script&lang=ts&"
export * from "./NDVBase.vue?vue&type=script&lang=ts&"
import style0 from "./NDVBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports